import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAuth } from "../redux/auth/actions";

const getDemoToken = () => {
  let token = sessionStorage.getItem('demoToken');
  if (!token) {
    token = `${Math.floor(Math.random() * 1000000000000)}`;
    sessionStorage.setItem('demoToken', token);
  }
  return token;
}

export default function useTokenAuth() {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const auth = useSelector((state: any) => state?.auth);

  if (!auth?.token || !auth?.subscriptionKey) {
    const demo = (searchParams.get('demo') === 'true');
    const token = demo ? getDemoToken() : searchParams.get("token");
    const subscriptionKey = demo ? 'RMQHPMAIWSzWQSDtRTlgVKDiaJAcmjZRfilqwHXaEmGZ' : searchParams.get("subscriptionKey");

    if (token?.length && subscriptionKey?.length) {
      dispatch(setAuth({ token, subscriptionKey, demo }));
      axios.defaults.headers.common["X-Subscription-Key"] = subscriptionKey;
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }

  return auth;
}
